const RefundPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Rückgaberecht</h1>
      <div className="prose max-w-none">
        <p className="text-gray-600 mb-6">
          Wir möchten, dass Sie mit Ihrem Kauf vollständig zufrieden sind. Hier ist unsere Rückgaberichtlinie:
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-4">Digitale Produkte</h2>
        <p className="text-gray-600 mb-4">
          Aufgrund der Beschaffenheit digitaler Produkte bieten wir nach der Auslieferung des Produkts
          grundsätzlich keine Rückerstattung an. Falls Sie jedoch technische Probleme haben, kontaktieren
          Sie bitte unseren Support: info@mapprints.de oder info.mapprints@gmail.com.
        </p>

        {/* Add more sections as needed */}
      </div>
    </div>
  );
};

const RefundPageEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>
      <div className="prose max-w-none">
        <p className="text-gray-600 mb-6">
          We want you to be completely satisfied with your purchase. Here's our refund policy:
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-4">Digital Products</h2>
        <p className="text-gray-600 mb-4">
          Due to the nature of digital products, we generally do not offer refunds once the product
          has been delivered. However, if you experience technical issues, please contact support: info@mapprints.de or info.mapprints@gmail.com.
        </p>

        {/* Add more sections as needed */}
      </div>
    </div>
  );
};

export { RefundPageDe, RefundPageEn };